export default __webpack_public_path__ + "static/media/star.42ed3691.svg";